import React, { ReactElement } from 'react';
import styles from './styles.module.css';
import { Logo } from '../../theme/icons';

const LogoPublic = (): ReactElement => (
  <div className={styles.logo}>
    <Logo />
  </div>
);

export default LogoPublic;
